import React from "react";
import "../styles/Footer.css";
import { FaDiscord, FaInstagram, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-socials">
        <a
          href="https://discord.rixxymc.fun/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaDiscord />
        </a>
        <a
          href="https://www.instagram.com/play.rixxymc.fun/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.youtube.com/@RixStonGamer?sub_confirmation=1"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaYoutube />
        </a>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} RixxyMC. All rights reserved.</p>
        <div className="footer-links">
          <a href="/privacy-policy" className="footer-link">
            Privacy Policy
          </a>
          <span className="footer-separator">|</span>
          <a href="/terms-of-service" className="footer-link">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
